/// <reference types="unplugin-icons/types/react" />
import type { ComponentType, SVGProps } from 'react';
import IconBankFilled from '~icons/ant-design/bank-filled';
import IconCreditCardFilled from '~icons/ant-design/credit-card-filled';
import IconEuroCircle from '~icons/majesticons/euro-circle';
import IconCashMultiple from '~icons/mdi/cash-multiple';
import IconAtm from '~icons/solar/cash-out-bold';
import { CashListSegment, CashListStorageType } from '@pflegenavi/shared/api';
import type {
  CashList,
  ICashListConfigurationContext,
} from './CashListConfigurationContext';
import { useCashListConfiguration } from './CashListConfigurationContext';

export type CashListIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

type CashListIconInput = Pick<CashList, 'id' | 'segment' | 'storageType'>;

type CashListIconConfiguration = Pick<
  ICashListConfigurationContext,
  | 'payoutTargetCashListId'
  | 'payinTargetCashListId'
  | 'serviceProviderPaymentTargetCashListId'
>;

export function getCashListIcon(
  cashList: CashListIconInput,
  configuration?: CashListIconConfiguration
): CashListIconComponent {
  if (
    configuration &&
    (cashList.id === configuration.payoutTargetCashListId ||
      cashList.id === configuration.payinTargetCashListId ||
      cashList.id === configuration.serviceProviderPaymentTargetCashListId)
  ) {
    return IconBankFilled;
  }

  if (cashList.storageType & CashListStorageType.Cash) {
    return cashList.segment === CashListSegment.NursingHome
      ? IconCashMultiple
      : IconAtm;
  }

  return cashList.segment === CashListSegment.NursingHome
    ? IconEuroCircle
    : IconCreditCardFilled;
}

export function useCashListIcon(
  cashList: CashListIconInput
): CashListIconComponent {
  const configuration = useCashListConfiguration();
  return getCashListIcon(cashList, configuration);
}
